export const ACCESS_ENTRIES = [
  { id: 'access-home', group: 'tools', label: 'Ask on Home', description: 'Start with your question.' },
  { id: 'access-header', group: 'tools', label: 'In the header', description: 'Open the panel on any page.' },
  { id: 'access-sidebar', group: 'tools', label: 'While reading', description: 'Reach Search beside the page.', desktopOnly: true },
  { id: 'access-gallery', group: 'spaces', label: 'Gallery', description: 'Browse the shared collection.' },
  { id: 'access-exhibition', group: 'spaces', label: 'Exhibition', description: 'Follow a View through its rooms.' },
];

export function accessEntries(device, orientation = 'portrait') {
  return ACCESS_ENTRIES.filter(entry => device !== 'phone' || (!entry.desktopOnly && (orientation !== 'landscape' || entry.group === 'spaces')));
}

export function accessViewport(device, orientation = 'portrait') {
  if (device !== 'phone') return { width: 1440, height: 920 };
  return orientation === 'landscape' ? { width: 780, height: 390 } : { width: 390, height: 780 };
}

export function accessSceneForDevice(scene, device, orientation = 'portrait') {
  return accessEntries(device, orientation).some(entry => entry.id === scene) ? scene : device === 'phone' && orientation === 'landscape' ? 'access-gallery' : 'access-header';
}
